import * as Yup from "yup";
import { TitleFormValues } from "./types";

export const apiEndpoint = `/title-configurations`;

export const validationSchema = Yup.object({
  titleName: Yup.string().trim().required("Title Name is required"),
  titleCode: Yup.string().trim().required("Title Code is required"),
  kafkaTopic: Yup.string().trim().required("Kafka Topic is required"),
});

export const TitleFormInitialValues: TitleFormValues = {
  titleName: "",
  titleCode: "",
  kafkaTopic: "",
  pushEnabled: false,
  isActive: true,
};

export const TitleFormFields = [
  { name: "titleName", label: "Title Name" },
  { name: "titleCode", label: "Title Code" },
  { name: "kafkaTopic", label: "Kafka Topic" },
];

export type ColumnKey =
  | "titleName"
  | "titleCode"
  | "kafkaTopic"
  | "pushEnabled"
  | "isActive"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy";

export const ColumnOptions: { value: string; label: string }[] = [
  { value: "titleName", label: "Name" },
  { value: "titleCode", label: "Code" },
  { value: "kafkaTopic", label: "Kafka Topic" },
  { value: "pushEnabled", label: "Push Enabled" },
  { value: "isActive", label: "Is Active" },
  { value: "createdAt", label: "Created At" },
  { value: "updatedAt", label: "Updated At" },
  { value: "createdBy", label: "Created By" },
  { value: "updatedBy", label: "Updated By" },
];

// Server-side sorting state (limited to allowed fields)
export const AllowedSortFields = [
  "titleName",
  "titleCode",
  "createdAt",
  "updatedAt",
] as const;

export type FormikErrorMap = {
  errors: Partial<Record<keyof TitleFormValues, string>>;
  touched: Partial<Record<keyof TitleFormValues, boolean>>;
};

// Split a raw API error string by comma and map parts to specific fields
export function mapApiMessageToFormikForm(message: string): FormikErrorMap {
  const parts = String(message)
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);

  const errors: Partial<Record<keyof TitleFormValues, string>> = {};
  const touched: Partial<Record<keyof TitleFormValues, boolean>> = {};

  const assignPart = (part: string) => {
    const lower = part.toLowerCase();
    let field: keyof TitleFormValues | undefined;
    if (lower.includes("kafka")) field = "kafkaTopic";
    else if (lower.includes("code") || lower.includes("titlecode"))
      field = "titleCode";
    else if (lower.includes("name") || lower.includes("titlename"))
      field = "titleName";

    if (field) {
      errors[field] = errors[field] ? `${errors[field]}, ${part}` : part;
      touched[field] = true;
    }
  };

  if (parts.length) {
    parts.forEach(assignPart);
  }

  if (Object.keys(errors).length === 0) {
    // Fallback if no known field was detected: attach to titleName
    errors.titleName = String(message);
    touched.titleName = true;
  }

  return { errors, touched };
}

export const DefaultHiddenColumns = [
  "createdAt",
  "createdBy",
  "updatedBy",
  "updatedAt",
];
